module.exports = __webpack_public_path__ + "static/img/IMG_20241209_182215.02d464fb.jpg";